import React, { useContext, useEffect, useState } from 'react';
import AuthContext from '../../../services/firebase/AuthContext';
import FireDataContext from '../../../services/firebase/FireDataContext';

import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import SettingsContent from './SettingsContent';

const SettingsPage = () => {
    const path = `config/settings`;
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);
    const [config, setConfig] = useState();

    useEffect(() => {
        if (currentUser?.roles?.includes('admin')) {
            db.get({
                path,
                context: 'SettingsPage'
            })
                .then(setConfig)
                .catch(error => console.log(error));
        }
    }, [db, currentUser, path]);

    if (!config) return <></>;

    const handleChange = ({ field, attributes }) => {
        setConfig({...config, [field]: attributes});
    }
    
    const saveChanges = () => {
        db.update({
            path,
            payload: config,
            context: 'SettingsPage'
        })
            .catch(error => console.log(error));
    }

    return (
        <MemberMiniMenu>
            <SettingsContent config={config} onChange={handleChange} onSave={saveChanges} />
        </MemberMiniMenu>
    );
};

export default SettingsPage;